import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Welcome to the Freon Tutorial",
description: "Follow this step-by-step tutorial to learn how to create your own domain-specific language (DSL) with Freon. Build editors, validators, and interpreters while exploring an example in the domain of Computer Aided Learning.",
tags: [ "tutorial", "introduction", "DSL", "domain-specific language", "Freon", "metamodel", "projectional editing", "TypeScript", "language workbench", "computer aided learning"] ,
modifiedTime: "2025-11-07T19:15:34.341Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};